export default __webpack_public_path__ + "static/media/Banner-Principal.87c0f8db.jpg";